import template from "./pdfViewer.html";
import { PdfViewerController } from "./pdfViewer.controller";

export const pdfViewerComponent = {
	name: "pdfViewer",
	restrict: "E",
	template,
	transclude: true,
	controllerAs: "vm",
	controller: PdfViewerController,
	bindings: {
		blob: "<",
		overlay: "<",
	},
};



// WEBPACK FOOTER //
// ./src/app/common/ui/pdfViewer/pdfViewer.component.js